//测试环境地址
export var API = "http://120.48.79.85:8003";

export var aiAPI = "http://101.200.166.238:9021/ai-server";

